import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import AdvancedFiltersModal from './AdvancedFiltersModal/index.vue'
import AddGroupModal from './AddGroupModal/index.vue'
import GroupsInfo from './GroupsInfo/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faCircleInfo,
	faCirclePlus,
	faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons'
import {
	faLinkedinIn,
	faInstagram,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons'

import { genId } from '@/helpers/gen-id'
import { sleep } from '@/helpers/sleep'
import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
import store from '@/store/store.js'
import pdf from './pdf'

library.add(
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faLinkedinIn,
	faInstagram,
	faYoutube,
	faCircleInfo,
	faCirclePlus,
	faMagnifyingGlass,
)

@Component({
	components: {
		Loader,
		vSelect,
		AdvancedFiltersModal,
		AddGroupModal,
		GroupsInfo,
	},
})
export default class Thermometer extends Vue {
	queryCompanyLoading = false
	loadingCompanies = true
	loadingSubjects = true
	loading = false
	printing = false
	pdfLoading = false
	documentTitle = ''
	board = [] as Array<any>

	form = {
		company: '',
		cliente: '',
		subject: '',
	}

	// temporary fields
	query = {
		company: [],
	}

	options = {
		calcSubjects: [] as Array<any>,
		companies: [] as Array<any>,
	}

	get user() {
		return store.user
	}

	get disableSendToBoard() {
		return !this.companiesLimit()
	}

	get companies() {
		return new Set(
			this.board.reduce((final, entry) => {
				const key = entry.isGroup
					? 'company_group_name'
					: 'company_name'

				if (entry[key]) final.push(entry[key])
				return final
			}, []),
		)
	}

	get items() {
		const items = [] as Array<any>

		const companies = this.board.reduce((companies, entry) => {
			const key = entry.isGroup ? 'company_group_name' : 'company_name'

			if (entry[key]) {
				Object.defineProperty(
					companies,
					this.companyNameAsKey(entry[key]),
					{
						enumerable: true,
						configurable: true,
						writable: true,
						value: false,
					},
				)
			}

			return companies
		}, {})

		const subjects = new Set(
			this.board.reduce((final, entry) => {
				final.push(entry.calc_subject.name)
				return final
			}, []),
		)

		subjects.forEach((subject) => {
			const row = {
				id: this.genId(),
				tese: subject,
				...companies,
			}

			// @ts-ignore
			if (this.form.cliente) row.cliente = false

			this.board.forEach((entry) => {
				if (subject === entry.calc_subject.name) {
					const key = entry.isGroup
						? 'company_group_name'
						: 'company_name'

					if (entry[key]) {
						row[this.companyNameAsKey(entry[key])] = true
					}
				}
			})

			items.push(row)
		})

		return items
	}

	get fields() {
		const fields = [
			{
				key: 'tese',
				label: 'Tese',
				thClass: 'w-45',
				tdClass: 'subject-cell-container',
			},
		] as Array<any>
		const tdClasses = function (value) {
			const defaultClasses = 'm-0 p-0 align-middle text-center '
			return defaultClasses + (value ? 'bg-primary' : 'bg-alt')
		}

		if (this.form.cliente && this.companies.size < 5) {
			fields.push({
				key: 'cliente',
				label: this.form.cliente,
				thClass: 'company-header-container',
				tdClass: tdClasses,
			})
		}

		const companies = new Set(
			this.board.reduce((final, entry) => {
				if (entry.isGroup) {
					if (entry.company_group_name) {
						final.push(entry.company_group_name + '--GROUP--')
					}
				} else if (entry.company_name) final.push(entry.company_name)
				return final
			}, []),
		)

		const regex = new RegExp('--GROUP--')
		companies.forEach((item) => {
			let isGroup = false
			if (regex.test(item as string)) {
				isGroup = true
				item = (item as string).replace(regex, '')
			}
			fields.push({
				key: this.companyNameAsKey(item),
				label: item,
				thClass: 'company-header-container',
				// @ts-ignore
				tdClass: tdClasses,
				isGroup,
			})
		})
		return fields
	}

	async loadCalcSubjects() {
		this.loadingSubjects = true
		const res = await api.get('/api/calc/subjects?outdated=false')
		this.options.calcSubjects.length = 0
		this.options.calcSubjects = res.data.map((calcSubject) => {
			return { id: calcSubject.id, name: calcSubject.name }
		})
		this.loadingSubjects = false
	}

	async loadCompanies() {
		this.loadingCompanies = true
		const res = await api.get(
			'/api/thermometer/collections/distinct/companies2',
		)
		this.options.companies.length = 0
		this.options.companies = res.data
		this.loadingCompanies = false
	}

	async queryEntriesByCompany() {
		if (!this.form.company) return
		this.queryCompanyLoading = true

		const res = await api.get(
			'/api/thermometer/collections/by/company?company=' +
				encodeURIComponent(this.form.company),
		)
		this.queryCompanyLoading = false

		if (res.ok) {
			this.query.company = res.data
		} else {
			console.info('error consulta')
		}
	}

	/*
	async loadMarketSectors() {
		this.loading = true
		const res = await api.get('/api/market-sectors')
		this.subjects.length = 0
		this.subjects = res.data
		this.loading = false
	}
	*/

	genId() {
		return genId()
	}

	companiesLimit() {
		return this.companies.size < 5
	}

	clearBoard() {
		this.board = []
	}

	async removeSubject(row) {
		document
			.querySelector(`[data-pk="${row.item.id}"]`)!
			.classList.add('deleting-row')

		// 1000ms = tempo da animacao
		await sleep(1000)
		this.board = this.board.filter(
			(entry) => entry.calc_subject.name !== row.value,
		)
	}

	addSubjectOnlyEntry() {
		const calcSubject = this.options.calcSubjects.find(
			(subject) => subject.id === this.form.subject,
		)
		this.board.push({
			calc_subject: {
				id: calcSubject.id,
				name: calcSubject.name,
			},
			city: null,
			cnj: null,
			cnpj: null,
			company_name: null,
			company_group_name: null,
			distribution_date: null,
			id: null,
			market_sector: {
				id: null,
				name: null,
			},
			multinational: null,
			publicly_traded: null,
			research_date: null,
			state: null,
			isGroup: false,
		})

		this.form.subject = ''
	}

	removeCompany(rowData) {
		if (rowData.column === 'cliente') {
			this.form.cliente = ''
			return
		}
		const company = rowData.label
		const key = rowData.field.isGroup
			? 'company_group_name'
			: 'company_name'

		this.board = this.board.filter((entry) => entry[key] !== company)
	}

	print() {
		pdf.clear()
		pdf.setUser(this.user.name, this.user.email)
		if (this.form.cliente) pdf.addHeader(this.form.cliente)

		this.companies.forEach((company) => {
			pdf.addHeader(company)
		})
		this.items.forEach((item, index) => {
			const row = [] as Array<any>
			row.push(index + 1 + ' - ' + item.tese)

			if (this.form.cliente) row.push(item.cliente)

			this.companies.forEach((company) => {
				row.push(item[this.companyNameAsKey(company)])
			})

			pdf.addRow(row)
		})
		pdf.download()
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	sendToBoard() {
		if (!this.form.company || this.disableSendToBoard) return

		// se a empresa já foi selecionada tenta inserir as entradas
		// porem nao insere duplicatas
		if (this.companies.has(this.form.company)) {
			for (let n = 0; n < this.query.company.length; n++) {
				const currentEntry = this.query.company[n]
				// @ts-ignore
				currentEntry.isGroup = false

				const found = this.board.find(
					// @ts-ignore
					(entry) => currentEntry.id === entry.id,
				)

				if (found) continue
				else this.board.push(currentEntry)
			}
			this.form.company = ''
			this.query.company = []
			return
		}

		this.board.push(...this.query.company)
		this.form.company = ''
		this.query.company = []
	}

	sendEntryToBoard(currentEntry) {
		const found = this.board.find(
			// @ts-ignore
			(entry) => currentEntry.id === entry.id,
		)

		currentEntry.isGroup = false

		if (!found) this.board.push(currentEntry)
	}

	sendToBoardAdvancedFilters(entries) {
		for (let n = 0; n < entries.length; n++) {
			if (this.disableSendToBoard) {
				this.$bvToast.toast('Limpe o quadro e tente novamente', {
					title: 'Limite de empresas atingido!',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				})
				return
			}

			const currentEntry = entries[n]
			currentEntry.isGroup = false
			const found = this.board.find(
				// @ts-ignore
				(entry) => currentEntry.id === entry.id,
			)

			if (found) continue
			else this.board.push(currentEntry)
		}
	}

	sendToBoardAddGroup(entries) {
		if (this.disableSendToBoard) {
			this.$bvToast.toast('Limpe o quadro e tente novamente', {
				title: 'Limite de empresas atingido!',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			return
		}

		for (let n = 0; n < entries.length; n++) {
			const currentEntry = entries[n]
			currentEntry.isGroup = true
			const found = this.board.find(
				// @ts-ignore
				(entry) => currentEntry.id === entry.id,
			)

			if (found) continue
			else this.board.push(currentEntry)
		}
	}

	companyNameAsKey(name) {
		let splittedName = name.toLowerCase().split(' ')
		if (splittedName.length > 1) {
			splittedName = splittedName[0] + splittedName[1]
		} else splittedName = splittedName[0]
		return splittedName
	}

	onSubjectsChange(event) {
		// @ts-ignore
		if (window.gtag) {
			// @ts-ignore
			const user = JSON.parse(localStorage.getItem('user'))
			// @ts-ignore
			window.gtag('event', 'termometro_teses_adicionadas', {
				identificador_usuario: 'id-' + user?.id,
				teses: JSON.parse(JSON.stringify(event)),
			})
		}
	}

	onCompanyChange(event) {
		if (!event) {
			this.query.company = []
			return
		}
		this.queryEntriesByCompany()
		// @ts-ignore
		if (window.gtag) {
			// @ts-ignore
			const user = JSON.parse(localStorage.getItem('user'))
			// @ts-ignore
			window.gtag('event', 'termometro_empresa_incluida', {
				identificador_usuario: 'id-' + user?.id,
				empresa: JSON.parse(JSON.stringify(event)),
			})
		}
	}

	setorPair(novoSetor) {
		if (novoSetor) {
			novoSetor = novoSetor.trim().toLowerCase()

			if (novoSetor.indexOf('indústria') >= 0) return 'Indústria'
			if (novoSetor.indexOf('serviços') >= 0) return 'Serviços'
			if (novoSetor.indexOf('comércio') >= 0) return 'Comércio'
		}

		switch (novoSetor) {
			case 'administração pública':
				return 'Serviços'
			case 'construção civil':
				return 'Indústria'
			case 'entretenimento':
				return 'Serviços'
			case 'instituições e mercado financeiro':
				return 'Serviços'
			case 'hotéis e restaurantes':
				return 'Serviços'
			case 'terceiro setor/associações':
				return 'Serviços'
			case 'viagens e lazer':
				return 'Serviços'
			case 'transportes e logística':
				return 'Comércio'
		}

		return ''
	}

	async mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		await this.loadCalcSubjects()
		await this.loadCompanies()
	}
}
